import React from "react"
import styled from "styled-components"

const SoftLightWrapper = styled.g`
  .blendst2 {
    stroke: #e6c370;
    stroke-width: 3;
  }
  .blendst2,
  .blendst3,
  .blendst5 {
    fill: none;
  }
  .blendst3 {
    stroke-width: 3;
    stroke: #000;
  }
  .blendst5 {
    stroke: #0071c1;
  }
  .sunst3 {
    fill: none;
    stroke: #000;
    stroke-width: 3;
  }
  .sunst3 {
    stroke: #1f190c;
    stroke-width: 2;
  }
  text {
    fill: #fff;
    font-size: 3rem;
  }
`

const SoftLightIcon = () => (
  <SoftLightWrapper>
    <filter id="sun-blur">
      <feGaussianBlur stdDeviation="7"></feGaussianBlur>
    </filter>
    <linearGradient
      id="sky-grad"
      x1="150"
      x2="150"
      y1="0"
      y2="300"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" stopColor="#00658d" />
      <stop offset="1" stopColor="#53bdfa" />
    </linearGradient>
    <circle cx="150" cy="150" r="150" fill="url(#sky-grad)" />
    <path
      fill="#e3c370"
      d="M212.09 126.75l-19.91-48.92c-.56-5.28-4.95-9.14-9.81-8.63l-90.24 9.49c-4.86.51-8.35 5.2-7.8 10.48 0 0-8.78 37.79-10.25 50.61-1.42 12.35-1.45 49.69-1.45 49.69.01.09.03.17.04.26.25.19.48 15.38.73 15.57 6.81-6.27 136.55-13.85 143.45-8.59-1.95-8.99-4.76-69.96-4.76-69.96z"
    />
    <g id="blender_1_">
      <g id="pitcher_1_">
        <path
          d="M217.49 17.04c-.19.12-.43.24-.7.37-4.17 1.92-17.41 4.84-18.21 6.43-2.05 4.11-4.02 14.04-4.02 14.04 5.39-10.09 19.89-9.66 32.65-14.63M89.48 80.39c-8.58 1-12.59-10.14-4.05-10.94 33.55-1.95 67.3-5.54 101.24-10.65 3.65-.38 8.06 1.68 7.13 4.28-2.3 6.41-7.94 6.5-7.94 6.5"
          className="blendst2"
        />
        <path
          d="M65.21 27.46c6.92 15.86 14.18 30.95 20.22 41.99l101.42-8.99c5.87-16.66 10.73-33.23 14.48-49.69M97.24 54.81C90.02 43.72 83.82 32 78.3 19.97M80.64 21.55l13.54-1.42M85.71 31.07l8.8-.93M91.89 43.82l19.81-2.08M98.55 54.84l13.54-1.42"
          className="blendst2"
        />
      </g>
    </g>
    <path
      id="rteye_1_"
      d="M133.96 106.83c11.89-7.95 18.99-2.09 23.73 10.62"
      className="blendst3"
    />
    <g id="face_1_">
      <path
        d="M90.75 115.3c4.7-13.51 13.9-13.11 25.34-5.82"
        className="blendst3"
      />
      <path
        fill="none"
        stroke="#000"
        d="M95.5 134.5c-6.56-.74-10.35 2.1-11 9"
      />
      <path d="M91.5 142.5c30.46 24.96 48.73 22.59 58 0" className="blendst3" />
    </g>
    <path
      id="rteye_1_"
      fill="none"
      d="M133.96 106.83c11.89-7.95 18.99-2.09 23.73 10.62"
      className="sunst1"
    />
    <path
      id="sun_1_"
      filter="url(#sun-blur)"
      fill="#fcff00"
      d="M239.27 134.95c18.07 22.81 5.13 59.31-27.64 62s-58.56-26.91-53.04-45.92c-19.88-28.4 10.52-70.04 43.29-72.73 32.77-2.7 51.39 33.91 37.39 56.65z"
    />
    <path
      id="rays"
      filter="url(#sun-blur)"
      fill="#fcff00"
      d="M28.35 235.51c1.17 1.67 2.38 3.3 3.61 4.91l141.05-76.38-71.21 126.95c2.39.83 4.81 1.59 7.26 2.3l79.96-119.22-3.8 120.73c3.25-.8 6.47-1.69 9.63-2.7l12.97-116.67 41.15 85.63c3.05-2.74 6-5.6 8.82-8.58l-32.69-84.66 59.87 44.61c1.92-4.13 3.66-8.35 5.2-12.67l-53.29-46.77 61.48 9.54c.39-4.34.61-8.73.63-13.17 0-.36-.01-.71-.01-1.06l-58.49-13.98 54.47-18.87c-1.11-4.69-2.45-9.29-3.99-13.79l-55.88 14.45 41.63-44.49c-2.5-4.03-5.18-7.93-8.04-11.69l-46.76 42.59 19.5-70.16c-3.56-2.77-7.25-5.39-11.06-7.84L204 96.65 184.66 5.06c-3.88-.93-7.82-1.71-11.82-2.32l12.58 97.11L108.8 6.78c-3.12.9-6.2 1.9-9.24 2.99l70.89 101.65-135-56.68c-1.57 1.88-3.09 3.8-4.56 5.75l131.64 68.18L1.16 143.21c-.09 1.97-.14 3.96-.15 5.95l162.44-1.5-135.1 87.85z"
      opacity=".4"
    />
    <g id="arms_2_">
      <path d="M127 178.55s40.55-10.38 81-46.05" className="sunst3" />
      <path
        d="M203.91 130.42l-.28 5.8 3.78 1.93M226.15 120.56l-1.21 4.35-4.14 3.38"
        className="sunst1"
      />
      <path d="M241 134.23s-13.48-2.97-18.42-11.89" className="sunst3" />
    </g>
    <g id="cloud_1_">
      <path
        id="cloudback_1_"
        fill="#fff"
        stroke="#0071c1"
        d="M79.21 204.11c11.53-17.88 30.05-28.3 77.37-8 25.22-20.19 102.64-5.61 99.32 37.32-2.05 26.4-21.32 37.79-50.81 41.76-20.61 17.76-49.09 19.55-85.46 5.33-17.3 2.93-33.03-2.08-47.35-14.22-16.24-4.95-33.37-12.96-30.03-33.76 2.44-15.18 18.6-23.39 36.96-28.43z"
      />
      <g id="cloudArcs_1_">
        <path
          d="M71.11 265.3c-36.19-6.31-44.55-52.18 6.82-60.31 7.34-1.16 15.05-1.89 23.51 2.52M135.69 277.41c-94.84 23.17-85.96-81.54-2.34-57.81M206.48 275.37c-23.72 17.58-64.04 17.59-89.76 3.89M123.42 257.8c31.57 20.29 85.68 4.41 71.03-19.41M193.32 256.91c30.44 0 51.86-16.76 36.08-33.53"
          className="blendst5"
        />
      </g>
    </g>
  </SoftLightWrapper>
)

export default SoftLightIcon

/*


*/
